import axiosClient from './AxiosClient';

const LandService = {
  async getList(params) {
    const response = await axiosClient.get('/land/', {params});

    // Build response and return
    return response.data;
  },

  async getImage(imageId, type) {
    const response = await axiosClient.get(`/land/bds/image/${imageId}/${type}`, {
        responseType: "blob",
    });
    const objectUrl = URL.createObjectURL(response);
    return objectUrl;
  },

  async getDetail(landId) {
    const url = `/land/${landId}`;
    const response = await axiosClient.get(url);
    return response.data.result;
  },

  create(data, images){
    var url = '/land/'
    const formData = new FormData();
  
    formData.append('data', JSON.stringify(data))
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i].originFileObj);
    }

    return axiosClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  update(landId, data, images) {
    const url = `/land/${landId}`;
    const formData = new FormData();
  
    formData.append('data', JSON.stringify(data))
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i].originFileObj);
    }

    return axiosClient.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  async remove(landId) {
    const url = `/land/${landId}`;
    return await axiosClient.delete(url)
  },
};

export default LandService;